import { createPortal } from "react-dom";
import { TiPlus } from "react-icons/ti";
import { BiTrash, BiEditAlt } from "react-icons/bi";
import { AiFillEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useState, useEffect, useRef } from "react";
import { baseurl } from "../BaseUrl/Baseurl";
import axios from "axios";
import { useSelector } from "react-redux";
import "./Commoncss.css";
import "./master.css"; // shared toolbar / drawer / actions-menu styles
import "./user.css"; // user-page specific responsive rules
import { Dropdown, Modal } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import InputTextField from "../InputText/InputText";
import { BsPersonFillCheck } from "react-icons/bs";
import {
  IoClose,
  IoPeopleOutline,
  IoMailOutline,
  IoCallOutline,
  IoLocationOutline,
  IoPersonOutline,
  IoGitNetworkOutline,
} from "react-icons/io5";
import {
  PiChartPieSliceFill,
  PiRoadHorizonBold,
  PiUserCircleFill,
} from "react-icons/pi";
import { IoIosBrowsers } from "react-icons/io";
import ReactPaginate from "react-paginate";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { TbFileExport } from "react-icons/tb";
import { HiOutlineDownload } from "react-icons/hi";
import CustomErrorToastContainer from "../Toast/ErrorToast";
import CustomSuccessToastContainer from "../Toast/SuccessToast";
import { ThreeDots } from "react-loader-spinner";
import { RiFilter2Fill } from "react-icons/ri";
import LogoutComponent from "../../Pages/Logout";

/* -------------------------------------------------------------------------- */
/* Constants + helpers                                                        */
/* -------------------------------------------------------------------------- */

// Filter hierarchy, top to bottom. `param` is the key sent to /api/user/filter.
const LEVELS = [
  { key: "wing", param: "wingId" },
  { key: "ce", param: "ceUserId" },
  { key: "circle", param: "circleId" },
  { key: "se", param: "seUserId" },
  { key: "division", param: "divisionId" },
  { key: "de", param: "deUserId" },
  { key: "subdiv", param: "subDivisionId" },
  { key: "ade", param: "adeUserId" },
  { key: "area", param: "areaId" },
  { key: "ae", param: "aeUserId" },
];

const EMPTY_FORM = {
  wing: "",
  ce: "",
  circle: "",
  se: "",
  division: "",
  de: "",
  subdiv: "",
  ade: "",
  area: "",
  ae: "",
};

const EMPTY_USER_FIELD = {
  name: "",
  mailid: "",
  contnum: "",
  pass: "",
  designation: "",
  location: "",
  role: "",
  area: "",

  // Validation state
  nameError: "",
  nameValid: false,
  mailError: "",
  mailValid: false,
  contnumError: "",
  contnumValid: false,
  passError: "",
  passValid: false,
  designationError: "",
  designationValid: false,
  locError: "",
  locValid: false,
  roleError: "",
  roleValid: false,
  areaError: "",
  areaValid: false,
};

// Which levels re-load the dependent dropdowns via /api/regions/hierarchy.
const HIERARCHY_PARAM = {
  wing: "wingId",
  circle: "circleId",
  division: "divisionId",
  subdiv: "subDivisionId",
  area: "areaId",
};

// One card per region + the person who owns it.
const FILTER_CARDS = [
  {
    region: {
      key: "wing",
      label: "Wing",
    },
    person: { key: "ce", label: "CE" },
    adminOnly: true,
  },
  {
    region: {
      key: "circle",
      label: "Circle",
    },
    person: { key: "se", label: "SE" },
    adminOnly: true,
  },
  {
    region: {
      key: "division",
      label: "Division",
    },
    person: { key: "de", label: "DE" },
    adminOnly: true,
  },
  {
    region: {
      key: "subdiv",
      label: "Subdivision",
    },
    person: { key: "ade", label: "ADE" },
  },
  {
    region: {
      key: "area",
      label: "Area",
    },
    person: { key: "ae", label: "AE" },
  },
];

// Request body from the first `upTo` levels of the filter form.
const buildFilters = (form, upTo = LEVELS.length) => {
  const filters = {};
  LEVELS.slice(0, upTo).forEach(({ key, param }) => {
    if (form[key]) filters[param] = [form[key].id];
  });
  return filters;
};

function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}

const ExcelIcon = ({ fill = "#fff", size = 20 }) => (
  <svg
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 50 50"
    aria-label="Excel file icon"
  >
    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z"></path>
  </svg>
);

const getInitials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join("") || "U";

const statusClass = (status = "") => {
  const s = String(status).toLowerCase();
  if (["active", "enabled"].includes(s)) return "is-active";
  if (["inactive", "disabled", "blocked"].includes(s)) return "is-inactive";
  return "is-neutral";
};

const roleSizeClass = (role = "") => {
  const len = String(role || "").trim().length;
  if (len <= 2) return "uc-role-sm";
  if (len === 3) return "uc-role-md";
  if (len <= 5) return "uc-role-lg";
  return "uc-role-xl";
};

// Compact inline item: icon + label + value
function Detail({ icon, label, title, children }) {
  return (
    <div className="uc-detail" title={title}>
      <span className="uc-detail-icon">{icon}</span>
      <span className="uc-detail-label">{label}:</span>
      <span className="uc-detail-value">{children || "-"}</span>
    </div>
  );
}

const extractName = (obj) => {
  if (obj === null || obj === undefined) return "";
  if (typeof obj !== "object") {
    const s = String(obj).trim();
    return s === "-" ? "" : s;
  }
  return (
    obj.name ||
    obj.areaName ||
    obj.subDivisionName ||
    obj.divisionName ||
    obj.circleName ||
    obj.wingName ||
    obj.subdivision ||
    obj.subDivision ||
    obj.division ||
    obj.circle ||
    obj.wing ||
    obj.area ||
    obj.value ||
    ""
  )
    .toString()
    .trim();
};

const resolveRegionValues = (item, keys) => {
  if (!item) return [];
  let best = [];
  for (const key of keys) {
    const val = item[key];
    if (val !== undefined && val !== null) {
      let arr = [];
      if (Array.isArray(val)) {
        arr = val;
      } else if (typeof val === "string") {
        const trimmed = val.trim();
        if (trimmed && trimmed !== "-") {
          arr = trimmed.includes(",")
            ? trimmed.split(",").map((s) => s.trim())
            : [trimmed];
        }
      } else if (typeof val === "object") {
        arr = [val];
      } else {
        const s = String(val).trim();
        if (s && s !== "-") arr = [s];
      }

      const cleaned = arr
        .map(extractName)
        .filter((v) => v !== "" && v !== "-");

      if (cleaned.length > best.length) {
        best = cleaned;
      }
    }
  }
  return best;
};

// Small pill: "Wing: value" or dropdown if multiple values
function RegionChip({ label, values }) {
  let list = [];

  if (Array.isArray(values)) {
    list = values;
  } else if (values) {
    list = [values];
  }

  const validList = list
    .map(extractName)
    .filter((v) => v !== "" && v !== "-");

  return (
    <div className="uc-region">
      <span className="uc-region-label">{label}</span>
      {validList.length > 1 ? (
        <Dropdown className="d-inline-flex align-items-center">
          <Dropdown.Toggle
            as="button"
            className="uc-region-view"
            type="button"
          >
            {validList.length} · View
          </Dropdown.Toggle>
          <Dropdown.Menu className="uc-region-dropdown-menu shadow-sm">
            <div className="uc-region-dropdown-header">
              {label} ({validList.length})
            </div>
            <div className="uc-region-dropdown-list">
              {validList.map((val, idx) => (
                <div key={idx} className="uc-region-dropdown-item">
                  {val}
                </div>
              ))}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <span className="uc-region-value" title={validList[0] || "-"}>
          {validList[0] || "-"}
        </span>
      )}
    </div>
  );
}
/* -------------------------------------------------------------------------- */
/* Page                                                                       */
/* -------------------------------------------------------------------------- */

const User = () => {
  const userData = useSelector((state) => state.userDetails);

  const isPhone = useMediaQuery("(max-width: 767.98px)");
  const isDesktop = useMediaQuery("(min-width: 992px)");

  /* ---------------- state persisted in sessionStorage ---------------- */

  const [requeststatus, setRequeststatus] = useState(() => {
    const stored = sessionStorage.getItem("usermodelstatus");
    return stored === "true";
  });
  const [role, setRole] = useState(() => {
    const stored = sessionStorage.getItem("userrole");
    return stored ? JSON.parse(stored) : "";
  });
  const [canShow, setCanShow] = useState(() => {
    const stored = sessionStorage.getItem("usercanshow");
    return stored === "true";
  });
  const [rolestatus, setRolestatus] = useState(() => {
    const stored = sessionStorage.getItem("userrolestatus");
    return stored === "true";
  });
  const [formData, setFormData] = useState(() => {
    const stored = sessionStorage.getItem("userformdata");
    return stored ? JSON.parse(stored) : { ...EMPTY_FORM };
  });

  const [wing, setWing] = useState(
    () => sessionStorage.getItem("userwing") || "",
  );
  const [circle, setCircle] = useState(
    () => sessionStorage.getItem("usercircle") || "",
  );
  const [division, setDivision] = useState(
    () => sessionStorage.getItem("userdivision") || "",
  );
  const [subdiv, setSubdiv] = useState(
    () => sessionStorage.getItem("usersubdiv") || "",
  );
  const [area, setArea] = useState(
    () => sessionStorage.getItem("userarea") || "",
  );

  const readJson = (key, fallback) => {
    const stored = sessionStorage.getItem(key);
    return stored ? JSON.parse(stored) : fallback;
  };

  const [areaList, setAreaList] = useState(() => readJson("userareaList", []));
  const [wingList, setWingList] = useState(() => readJson("userwingListt", []));
  const [circleList, setCircleList] = useState(() =>
    readJson("usercircleList", []),
  );
  const [divList, setDivList] = useState(() => readJson("userdivList", []));
  const [subdivList, setSubdivList] = useState(() =>
    readJson("usersubdivList", []),
  );

  const [fieldValues, setFieldValues] = useState(() => [
    { ...EMPTY_USER_FIELD },
  ]);

  const [showPassword, setShowPassword] = useState({});

  const [ceOptions, setCeOptions] = useState(() =>
    readJson("userceOptions", []),
  );
  const [seOptions, setSeOptions] = useState(() =>
    readJson("userseOptions", []),
  );
  const [deOptions, setDeOptions] = useState(() =>
    readJson("userdeOptions", []),
  );
  const [adeOptions, setAdeOptions] = useState(() =>
    readJson("useradeOptions", []),
  );
  const [aeOptions, setAeOptions] = useState(() =>
    readJson("useraeOptions", []),
  );

  const [isCreatingUser, setIsCreatingUser] = useState(false);
  const [isUploadingFile, setIsUploadingFile] = useState(false);

  useEffect(() => {
    sessionStorage.setItem("usermodelstatus", JSON.stringify(requeststatus));
    sessionStorage.setItem("userrole", JSON.stringify(role));
    sessionStorage.setItem("userrolestatus", JSON.stringify(rolestatus));
    sessionStorage.setItem("usercanshow", JSON.stringify(canShow));
    sessionStorage.setItem("userformdata", JSON.stringify(formData));

    sessionStorage.setItem("userareaList", JSON.stringify(areaList));
    sessionStorage.setItem("userwingListt", JSON.stringify(wingList));
    sessionStorage.setItem("usercircleList", JSON.stringify(circleList));
    sessionStorage.setItem("userdivList", JSON.stringify(divList));
    sessionStorage.setItem("usersubdivList", JSON.stringify(subdivList));

    sessionStorage.setItem("userwing", wing);
    sessionStorage.setItem("usercircle", circle);
    sessionStorage.setItem("userdivision", division);
    sessionStorage.setItem("usersubdiv", subdiv);
    sessionStorage.setItem("userarea", area);

    sessionStorage.setItem("useraeOptions", JSON.stringify(aeOptions));
    sessionStorage.setItem("useradeOptions", JSON.stringify(adeOptions));
    sessionStorage.setItem("userdeOptions", JSON.stringify(deOptions));
    sessionStorage.setItem("userseOptions", JSON.stringify(seOptions));
    sessionStorage.setItem("userceOptions", JSON.stringify(ceOptions));
  }, [
    requeststatus,
    role,
    rolestatus,
    canShow,
    formData,
    wing,
    circle,
    division,
    subdiv,
    area,
    wingList,
    circleList,
    divList,
    subdivList,
    areaList,
    aeOptions,
    adeOptions,
    seOptions,
    deOptions,
    ceOptions,
  ]);

  /* ---------------- plain state ---------------- */

  const [tokenMsg, setTokenMsg] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [renewallist, setRenewallist] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const [totalpageno, setTotalpageno] = useState(0);
  const [addRole, setAddRole] = useState("");
  const [roleerror, setRoleerror] = useState("");
  const [formErr, setFormErr] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const [createFormErr, setCreateFormErr] = useState("");
  const [fileErr, setFileErr] = useState("");
  const [roleList, setRoleList] = useState([]);
  const [circleFilterList, setCircleFilterList] = useState([]);
  const [divFilterList, setdivFilterList] = useState([]);
  const [subdivFilterList, setsubdivFilterList] = useState([]);
  const [areaFilterList, setareaFilterList] = useState([]);

  const [successtoastmsg, setSuccesstoastmsg] = useState("");
  const [successtoastmsgstatus, setSuccesstoastmsgstatus] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [messageList, setMessageList] = useState("");

  /* ---------------- edit & delete user state ---------------- */
  const [editModal, setEditModal] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [editData, setEditData] = useState({
    name: "",
    contactNumber: "",
    designation: "",
    location: "",
    isLocked: 0,
    activeStatus: 1,
    wing: "",
    circle: "",
    division: "",
    subDivision: "",
    area: "",
  });
  const [editErrors, setEditErrors] = useState({});
  const [editWing, setEditWing] = useState("");
  const [initialWing, setInitialWing] = useState("");
  const [editWingList, setEditWingList] = useState([]);
  const [editCircle, setEditCircle] = useState("");
  const [initialCircle, setInitialCircle] = useState("");
  const [editCircleList, setEditCircleList] = useState([]);
  const [editDivision, setEditDivision] = useState("");
  const [initialDivision, setInitialDivision] = useState("");
  const [editDivisionList, setEditDivisionList] = useState([]);
  const [editSubdiv, setEditSubdiv] = useState("");
  const [initialSubdiv, setInitialSubdiv] = useState("");
  const [editArea, setEditArea] = useState("");
  const [initialArea, setInitialArea] = useState("");
  const [editSubdivList, setEditSubdivList] = useState([]);
  const [editAreaList, setEditAreaList] = useState([]);
  const [initialEditData, setInitialEditData] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [editSubmitErr, setEditSubmitErr] = useState("");

  const [deleteModal, setDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const [showFilters, setShowFilters] = useState(false); // filter drawer (below lg)
  const fileInputRef = useRef(null); // used by the mobile "Upload File" menu item

  // Dropdown options for each filter level.
  const optionsByKey = {
    wing: wingList,
    ce: ceOptions,
    circle: circleFilterList,
    se: seOptions,
    division: divFilterList,
    de: deOptions,
    subdiv: subdivFilterList,
    ade: adeOptions,
    area: areaFilterList,
    ae: aeOptions,
  };

  /* ---------------- API helpers ---------------- */

  const authHeaders = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + userData.token,
  };

  const fetchUsers = (pgNo, filters) =>
    axios({
      method: "POST",
      url: `${baseurl}/api/user/filter?userId=${userData.userId}&pgNo=${pgNo}&isSortingRequired=1`,
      headers: authHeaders,
      data: filters,
    });

  const applyUsers = (res) => {
    setRenewallist(res.data?.users || []);
    setTotalpageno(res.data?.totalPages || 0);
    setisLoading(false);
  };

  const applyHierarchy = (full) => {
    if (full.wingList) setWingList(full.wingList);
    if (full.circleList) setCircleFilterList(full.circleList);
    if (full.divisionList) setdivFilterList(full.divisionList);
    if (full.subDivisionList) setsubdivFilterList(full.subDivisionList);
    if (full.areaList) setareaFilterList(full.areaList);
    if (full.ceNameList) setCeOptions(full.ceNameList);
    if (full.seNameList) setSeOptions(full.seNameList);
    if (full.deNameList) setDeOptions(full.deNameList);
    if (full.aeNameList) setAeOptions(full.aeNameList);
    if (full.adeNameList) setAdeOptions(full.adeNameList);
  };

  const loadHierarchy = (data) =>
    axios({
      method: "POST",
      url:
        baseurl +
        "/api/regions/hierarchy" +
        "?userId=" +
        userData.userId +
        "&isSortingRequired=2",
      headers: { Authorization: "Bearer " + userData.token },
      data,
    })
      .then((response) => applyHierarchy(response.data))
      .catch((err) => {
        console.error(err);
      });

  // DE users only see their own division's hierarchy.
  const baseHierarchyBody = () =>
    userData.role === "DE" ? { divisionId: userData.divId } : {};

  const resetFilters = () => {
    setCurrentPage(1);
    setFormData({ ...EMPTY_FORM });
    sessionStorage.setItem("userformdata", JSON.stringify(EMPTY_FORM));
    setAdeOptions([]);
    setAeOptions([]);
    sessionStorage.setItem("useradeOptions", JSON.stringify([]));
    sessionStorage.setItem("useraeOptions", JSON.stringify([]));
    loadHierarchy(baseHierarchyBody());
    setRenewallist([]);
    setisLoading(true);
    fetchUsers(1, {})
      .then(applyUsers)
      .catch(() => setisLoading(false));
  };

  /* ---------------- create user ---------------- */

  const ToclosesuccessToast = () => {
    setSuccesstoastmsg("");
    setSuccesstoastmsgstatus(false);
  };

  const handleCreate = () => {
    let userCreate = fieldValues.map((item) => ({
      password: item.pass,
      email: item.mailid,
      name: item.name,
      contactNumber: item.contnum,
      designation: item.designation,
      location: item.location,
      role: role,
      wing: Number.parseInt(wing),
      circle: Number.parseInt(circle),
      division: Number.parseInt(division),
      subDivision: Number.parseInt(subdiv),
      area: Number.parseInt(area),
    }));

    let userdetails = { newUserRequest: userCreate };

    setIsCreatingUser(true);

    axios({
      method: "POST",
      url: baseurl + "/api/user/add?userId=" + userData.userId,
      data: userdetails,
      headers: authHeaders,
    })
      .then((response) => {
        const RequestData = response.data.message;
        setSuccesstoastmsg(RequestData);
        setSuccesstoastmsgstatus(true);
        handleClose();
        resetFilters();
      })
      .catch((error) => {
        setMessageList(error.response?.data?.message || "Something went wrong");
        setShowToast(true);
      })
      .finally(() => {
        setIsCreatingUser(false);
      });
  };

  const handleCreateUser = (e) => {
    e.preventDefault();
    if (isCreatingUser) return;

    const isValid =
      (role === "AE" && wing && circle && division && subdiv && area) ||
      (role === "ADE" && wing && circle && division && subdiv) ||
      (role === "CE" && wing) ||
      (role === "DE" && wing && circle && division) ||
      (role === "SE" && wing && circle);

    const validationResults = fieldValues.map(
      (field) =>
        field.name != "" &&
        field.mailid != "" &&
        field.contnum != "" &&
        field.pass != "",
    );

    const allValid = !validationResults.includes(false);

    if (allValid && isValid) {
      handleCreate();
    } else {
      setCreateFormErr("Please Fill All The Fields");
    }
  };

  const requestdata1 = () => {
    sessionStorage.removeItem("userfieldValues");
    setShowPassword({});
    setFieldValues([{ ...EMPTY_USER_FIELD }]);
    setRequeststatus(true);
  };

  const handleClose = () => {
    if (isCreatingUser) return;
    sessionStorage.removeItem("userfieldValues");
    setRequeststatus(false);
    setCanShow(false);
    setWing("");
    setCircle("");
    setDivision("");
    setSubdiv("");
    setCreateFormErr("");
    setFileErr("");
    setFormErr("");
    setShowPassword({});
    setFieldValues([{ ...EMPTY_USER_FIELD }]);
    setRole("");
    setRolestatus(false);
    setRoleerror("");
  };

  /* ---------------- initial loads ---------------- */

  useEffect(() => {
    sessionStorage.removeItem("userfieldValues");
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    axios({
      method: "GET",
      url: baseurl + "/api/get/list?field=role" + "&userId=" + userData.userId,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + userData.token,
      },
    })
      .then((response) => {
        const RequestData = response?.data?.message;

        if (userData.role === "DE") {
          setRoleList(["DE", "ADE", "AE"]);
        } else {
          setRoleList(RequestData);
        }
      })
      .catch((error) => {
        if (error.response?.data?.message !== undefined) {
          setTokenMsg(error.response.data.message);
        }
      });
  }, [!canShow]);

  // First load of the list (respects filters restored from the session).
  useEffect(() => {
    if (renewallist?.length == 0) {
      fetchUsers(1, buildFilters(formData))
        .then(applyUsers)
        .catch(() => setisLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadHierarchy(baseHierarchyBody());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Which hierarchy levels trigger each list update.
  // Defined outside the component so it isn't recreated on every render.
  const FILTER_RULES = [
    { key: "circleList", levels: ["wingId"] },
    { key: "divisionList", levels: ["circleId", "wingId"] },
    { key: "subDivisionList", levels: ["circleId", "wingId", "divisionId"] },
    {
      key: "areaList",
      levels: ["subDivisionId", "circleId", "wingId", "divisionId"],
    },
    { key: "ceNameList", levels: ["wingId"] },
    { key: "seNameList", levels: ["circleId", "wingId"] },
    { key: "deNameList", levels: ["circleId", "wingId", "divisionId"] },
    {
      key: "aeNameList",
      levels: [
        "subDivisionId",
        "circleId",
        "wingId",
        "divisionId",
        "areaId",
      ],
    },
    {
      key: "adeNameList",
      levels: ["subDivisionId", "circleId", "wingId", "divisionId"],
    },
  ];

  // Inside the component
  const getFilters = (regeionname, id) => {
    // Maps each response field to its state setter.
    const setters = {
      circleList: setCircleFilterList,
      divisionList: setdivFilterList,
      subDivisionList: setsubdivFilterList,
      areaList: setareaFilterList,
      ceNameList: setCeOptions,
      seNameList: setSeOptions,
      deNameList: setDeOptions,
      aeNameList: setAeOptions,
      adeNameList: setAdeOptions,
    };

    axios({
      method: "POST",
      url:
        baseurl +
        "/api/regions/hierarchy" +
        "?userId=" +
        userData.userId +
        "&isSortingRequired=2",
      headers: { Authorization: "Bearer " + userData.token },
      data: { [regeionname]: id },
    })
      .then((response) => {
        const fulllist = response.data;

        FILTER_RULES.forEach(({ key, levels }) => {
          if (fulllist[key] && levels.includes(regeionname)) {
            setters[key](fulllist[key]);
          }
        });
      })
      .catch(() => { });
  };

  const handleRoleValues = (key, value, setter) => {
    axios({
      method: "POST",
      url:
        baseurl +
        "/api/project/user-based-on-region?userId=" +
        userData.userId +
        "&isSortingRequired=2",
      data: { [key]: [value] },
      headers: authHeaders,
    })
      .then((response) => setter(response.data.userNameList))
      .catch((err) => {
        console.error(err);
      });
  };

  /* ---------------- create-user modal handlers ---------------- */

  function handleRole(e) {
    setRole(e.target.value.replace(/\s+/g, ""));
    validateField(e.target.name, e.target.value);
    setCreateFormErr("");

    const value = e.target.value;
    if (value != "" && value != "Add New Role") {
      setRolestatus(true);
    } else {
      setRolestatus(false);
    }
    if (value === "Add New Role") {
      setCanShow(true);
      setRolestatus(false);
    }

    setFormSuccess("");
  }

  const handleInputChange = (e, index, fieldName) => {
    const updatedFieldValues = [...fieldValues];
    let value = e.target.value;
    if (fieldName === "contnum" && value.length > 10) {
      value = value.slice(0, 10);
    }
    updatedFieldValues[index][fieldName] = value;
    setFieldValues(updatedFieldValues);
    setCreateFormErr("");
    setFileErr("");
    setFormErr("");
    setRoleerror("");
    validateField(fieldName, value, index);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    let userData1 = new FormData();
    userData1.append("file", file);
    e.target.value = ""; // allow picking the same file again
    setFileErr("");
    setFormErr("");
    setRoleerror("");

    setIsUploadingFile(true);

    axios({
      method: "POST",
      url:
        `${baseurl}/api/import-data-from-excel-for-user` +
        "?userId=" +
        userData.userId,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userData.token}`,
      },
      data: userData1,
    })
      .then((response) => {
        setSuccesstoastmsg(response.data.message);
        setSuccesstoastmsgstatus(true);
        resetFilters();
      })
      .catch((error) => {
        setMessageList(error.response?.data?.message || "Upload failed");
        setShowToast(true);
      })
      .finally(() => {
        setIsUploadingFile(false);
      });
  };

  const addFields = (e) => {
    e.preventDefault();
    setFieldValues((prev) => [
      ...prev,
      { ...EMPTY_USER_FIELD },
    ]);
  };

  const removeFields = (indexToRemove) => {
    if (fieldValues.length <= 1) {
      setShowPassword({});
      setFieldValues([{ ...EMPTY_USER_FIELD }]);
      return;
    }

    setFieldValues((prev) => prev.filter((_, idx) => idx !== indexToRemove));
    setShowPassword((prev) => {
      const next = {};
      Object.keys(prev).forEach((k) => {
        const num = Number(k);
        if (num < indexToRemove) {
          next[num] = prev[k];
        } else if (num > indexToRemove) {
          next[num - 1] = prev[k];
        }
      });
      return next;
    });
  };

  function handleWing(e) {
    setWing(e.target.value);
    validateField(e.target.name, e.target.value);
    setCreateFormErr("");
    setCircleList([]);
    setDivList([]);
    setSubdivList([]);
    setAreaList([]);
    if (e.target.value != "") {
      axios({
        method: "GET",
        url:
          baseurl +
          "/api/get/list?field=circle&wingId=" +
          e.target.value +
          "&userId=" +
          userData.userId +
          "&isSortingRequired=2",
        headers: { Authorization: "Bearer " + userData.token },
      })
        .then((response) => setCircleList(response.data.message))
        .catch((err) => {
          console.error(err);
        });
    }
  }

  function handleCircle(e) {
    const selectedCircle = e.target.value;
    setCircle(selectedCircle);
    validateField(e.target.name, selectedCircle);
    setCreateFormErr("");
    setDivList([]);
    setSubdivList([]);
    setAreaList([]);

    if (selectedCircle != "") {
      axios({
        method: "GET",
        url:
          baseurl +
          "/api/get/list?field=division" +
          "&userId=" +
          userData.userId +
          "&isSortingRequired=2",
        params: { circleId: selectedCircle, isSortingRequired: 2 },
        headers: { Authorization: "Bearer " + userData.token },
      })
        .then((response) => setDivList(response.data.message))
        .catch((err) => {
          console.error(err);
        });
    }
  }

  function handleDivision(e) {
    const selectedDivision = e.target.value;
    setDivision(selectedDivision);
    validateField(e.target.name, selectedDivision);
    setCreateFormErr("");
    setSubdivList([]);
    setAreaList([]);

    if (selectedDivision != "") {
      axios({
        method: "GET",
        url:
          baseurl +
          "/api/get/list?field=subDivision" +
          "&userId=" +
          userData.userId +
          "&isSortingRequired=2",
        params: { divisionId: selectedDivision, isSortingRequired: 2 },
        headers: { Authorization: "Bearer " + userData.token },
      })
        .then((response) => setSubdivList(response.data.message))
        .catch((err) => {
          console.error(err);
        });
    }
  }

  function handleSubDivision(e) {
    const selectedSubDivision = e.target.value;
    validateField(e.target.name, selectedSubDivision);
    setSubdiv(selectedSubDivision);
    setCreateFormErr("");
    setAreaList([]);

    if (selectedSubDivision != "") {
      axios({
        method: "GET",
        url:
          baseurl +
          "/api/get/list?field=area" +
          "&userId=" +
          userData.userId +
          "&isSortingRequired=2",
        params: { subDivisionId: selectedSubDivision, isSortingRequired: 2 },
        headers: { Authorization: "Bearer " + userData.token },
      })
        .then((response) => setAreaList(response.data.message))
        .catch((err) => {
          console.error(err);
        });
    }
  }

  const handleArea = (e) => {
    const selectedArea = e.target.value;
    validateField(e.target.name, selectedArea);
    setArea(selectedArea);
    setCreateFormErr("");
  };

  const EMAIL_REGEX = /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/;
  const PASSWORD_REGEX =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/;
  const PASSWORD_RULE_MSG =
    "Password should be at least 6 characters and include lowercase, uppercase, numeric, and special characters.";

  // Validator returns an error message, or "" when the value is valid.
  const requiredRule = (errorKey, validKey, message) => ({
    errorKey,
    validKey,
    validate: (value) => (value !== "" ? "" : message),
  });

  const FIELD_RULES = {
    contnum: {
      errorKey: "contnumError",
      validKey: "contnumValid",
      validate: (value) => {
        if (!value || value.length === 0) {
          return "Please enter a valid 10-digit number";
        }
        if (!/^\d+$/.test(value)) {
          return "Enter numbers only";
        }
        if (!/^[6-9]/.test(value)) {
          return "Contact number must start with 6, 7, 8, or 9";
        }
        if (value.length !== 10) {
          return "Please enter a valid 10-digit number";
        }
        return "";
      },
    },
    area: requiredRule("areaError", "areaValid", "Please Choose Area"),
    name: requiredRule("nameError", "nameValid", "Please Enter Valid Name"),
    designation: {
      errorKey: "designationError",
      validKey: "designationValid",
      validate: (value) => {
        if (!value || value === "") return "";
        if (value.trim() === "") return "Spaces alone are not allowed";
        return "";
      },
    },
    location: {
      errorKey: "locError",
      validKey: "locValid",
      validate: (value) => {
        if (!value || value === "") return "";
        if (value.trim() === "") return "Spaces alone are not allowed";
        return "";
      },
    },
    mailid: {
      errorKey: "mailError",
      validKey: "mailValid",
      validate: (value) =>
        EMAIL_REGEX.test(value) ? "" : "Please enter a valid email",
    },
    pass: {
      errorKey: "passError",
      validKey: "passValid",
      validate: (value) => {
        if (value.length === 0) return "Please enter a password.";
        return PASSWORD_REGEX.test(value) ? "" : PASSWORD_RULE_MSG;
      },
    },
  };

  const validateField = (fieldName, value, index) => {
    const rule = FIELD_RULES[fieldName];
    if (!rule) return;

    const error = rule.validate(value);

    setFieldValues((prev) => {
      const updatedFields = [...prev];
      updatedFields[index] = {
        ...updatedFields[index],
        [rule.errorKey]: error,
        [rule.validKey]: error === "",
      };
      return updatedFields;
    });
  };

  const handleAddRoleChange = (e) => {
    setAddRole(e.target.value);
    setFormErr("");
    setCreateFormErr("");
  };

  const handleRolebtn = () => {
    setFormErr("");
    let userData1 = { role: addRole };
    axios({
      method: "POST",
      url: `${baseurl}/api/list/add?userId=${userData.userId}&field=role`,
      headers: authHeaders,
      data: userData1,
    })
      .then((response) => {
        setAddRole("");
        setCanShow(false);
        setRole("");
        setFormSuccess(response.data.message);
      })
      .catch((error) => {
        setFormErr(error.response?.data?.message || "Something went wrong");
      });
  };

  /* ---------------- list, filters, paging ---------------- */

  const handlePageClick = (pagedetails) => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    const pgno = Number.parseInt(pagedetails.selected) + 1;
    setCurrentPage(pgno);
    setisLoading(true);
    fetchUsers(pgno, buildFilters(formData))
      .then(applyUsers)
      .catch(() => setisLoading(false));
  };



  const TocloseToast1 = () => {
    setMessageList("");
    setShowToast(false);
  };

  // Lists to empty when a level changes (the old behaviour, kept as-is).
  const clearOnSelect = {
    wing: [
      setSeOptions,
      setAeOptions,
      setAdeOptions,
      setDeOptions,
      setCircleList,
      setDivList,
      setSubdivList,
      setAreaList,
    ],
    circle: [
      setAeOptions,
      setAdeOptions,
      setDeOptions,
      setDivList,
      setSubdivList,
      setAreaList,
    ],
    division: [setAeOptions, setAdeOptions, setSubdivList, setAreaList],
    subdiv: [setAeOptions, setAreaList],
  };

  const handleSelectChange = (e) => {
    const { name: type, value } = e.target;
    if (value === "") return;

    const index = LEVELS.findIndex((l) => l.key === type);
    if (index < 0) return;

    const selected = (optionsByKey[type] || []).find((o) => o.name === value);

    (clearOnSelect[type] || []).forEach((clear) => clear([]));

    // Store the pick and reset every level below it.
    setFormData((prev) => {
      const next = { ...prev, [type]: selected || "" };
      LEVELS.slice(index + 1).forEach(({ key }) => {
        next[key] = "";
      });
      return next;
    });

    if (!selected) return;

    if (HIERARCHY_PARAM[type]) getFilters(HIERARCHY_PARAM[type], selected.id);
    if (type === "area") handleRoleValues("area", selected.id, setAeOptions);

    // Selected levels above this one + the new pick.
    const filters = {
      ...buildFilters(formData, index),
      [LEVELS[index].param]: [selected.id],
    };

    setRenewallist([]);
    setCurrentPage(1);
    setisLoading(true);
    fetchUsers(1, filters)
      .then(applyUsers)
      .catch(() => setisLoading(false));
  };

  const handleRemoveFilter = () => {
    resetFilters();
  };

  /* ---------------- edit & delete user handlers ---------------- */

  const matchIdInList = (list, idVal, nameVal) => {
    if (!list || list.length === 0) return "";
    if (idVal != null && idVal !== "") {
      const found = list.find((item) => String(item.id) === String(idVal));
      if (found) return String(found.id);
      return String(idVal);
    }
    if (!nameVal) return "";
    const nameStr = Array.isArray(nameVal) ? nameVal[0] : nameVal;
    if (!nameStr) return "";
    const found = list.find(
      (item) =>
        String(item.name).trim().toLowerCase() ===
          String(nameStr).trim().toLowerCase() ||
        String(item.id) === String(nameStr),
    );
    return found ? String(found.id) : "";
  };

  const handleOpenEdit = (user) => {
    setEditUser(user);
    setEditSubmitErr("");
    setEditErrors({});

    let initialIsLocked = 0;
    if (user.isLocked != null) {
      initialIsLocked =
        user.isLocked === 1 || user.isLocked === true || String(user.isLocked) === "1"
          ? 1
          : 0;
    } else if (
      user.status &&
      ["locked", "blocked"].includes(String(user.status).toLowerCase())
    ) {
      initialIsLocked = 1;
    }

    let initialActiveStatus = 1;
    if (user.activeStatus != null) {
      initialActiveStatus =
        user.activeStatus === 1 ||
        user.activeStatus === true ||
        String(user.activeStatus) === "1"
          ? 1
          : 0;
    } else if (user.status) {
      const s = String(user.status).toLowerCase();
      if (["inactive", "disabled", "blocked"].includes(s)) {
        initialActiveStatus = 0;
      } else {
        initialActiveStatus = 1;
      }
    }

    const initialVals = {
      name: user.name || "",
      contactNumber: user.contactNumber || "",
      designation: user.designation || "",
      location: user.location || "",
      isLocked: initialIsLocked,
      activeStatus: initialActiveStatus,
      wing: Array.isArray(user.wing) ? user.wing.join(", ") : user.wing || "",
      circle: Array.isArray(user.circle) ? user.circle.join(", ") : user.circle || "",
      division: Array.isArray(user.division) ? user.division.join(", ") : user.division || "",
    };

    setEditData(initialVals);
    setInitialEditData(initialVals);
    setEditWing("");
    setInitialWing("");
    setEditWingList([]);
    setEditCircle("");
    setInitialCircle("");
    setEditCircleList([]);
    setEditDivision("");
    setInitialDivision("");
    setEditDivisionList([]);
    setEditSubdiv("");
    setInitialSubdiv("");
    setEditArea("");
    setInitialArea("");
    setEditSubdivList([]);
    setEditAreaList([]);

    const wList = wingList && wingList.length > 0 ? wingList : [];
    setEditWingList(wList);

    const matchedWingId = matchIdInList(wList, user.wingId, user.wing);
    setEditWing(matchedWingId);
    setInitialWing(matchedWingId);

    const uRole = String(user?.role || "").trim().toUpperCase();
    const needsWing = ["CE", "SE", "DE", "ADE", "AE"].includes(uRole);
    const needsCircle = ["SE", "DE", "ADE", "AE"].includes(uRole);
    const needsDivision = ["DE", "ADE", "AE"].includes(uRole);
    const needsSubdiv = ["ADE", "AE"].includes(uRole);
    const needsArea = uRole === "AE";

    if (needsWing) {
      if (matchedWingId && needsCircle) {
        axios({
          method: "GET",
          url: `${baseurl}/api/get/list?field=circle&wingId=${matchedWingId}&userId=${userData.userId}&isSortingRequired=2`,
          headers: { Authorization: "Bearer " + userData.token },
        })
          .then((circleRes) => {
            const cList = circleRes.data?.message || [];
            setEditCircleList(cList);

            const matchedCircleId = matchIdInList(cList, user.circleId, user.circle);
            setEditCircle(matchedCircleId);
            setInitialCircle(matchedCircleId);

            if (matchedCircleId && needsDivision) {
              axios({
                method: "GET",
                url: `${baseurl}/api/get/list?field=division&circleId=${matchedCircleId}&userId=${userData.userId}&isSortingRequired=2`,
                params: { circleId: matchedCircleId, isSortingRequired: 2 },
                headers: { Authorization: "Bearer " + userData.token },
              })
                .then((divRes) => {
                  const dList = divRes.data?.message || [];
                  setEditDivisionList(dList);

                  const matchedDivId = matchIdInList(dList, user.divisionId, user.division);
                  setEditDivision(matchedDivId);
                  setInitialDivision(matchedDivId);

                  const divForSub = matchedDivId || user.divisionId || userData?.divId;
                  if (divForSub && needsSubdiv) {
                    axios({
                      method: "GET",
                      url: `${baseurl}/api/get/list?field=subDivision&userId=${userData.userId}&isSortingRequired=2`,
                      params: { divisionId: divForSub, isSortingRequired: 2 },
                      headers: { Authorization: "Bearer " + userData.token },
                    })
                      .then((subRes) => {
                        const sList = subRes.data?.message || [];
                        setEditSubdivList(sList);

                        const matchedSubId = matchIdInList(sList, user.subDivisionId, user.subDivision);
                        setEditSubdiv(matchedSubId);
                        setInitialSubdiv(matchedSubId);

                        if (matchedSubId && needsArea) {
                          axios({
                            method: "GET",
                            url: `${baseurl}/api/get/list?field=area&userId=${userData.userId}&isSortingRequired=2`,
                            params: { subDivisionId: matchedSubId, isSortingRequired: 2 },
                            headers: { Authorization: "Bearer " + userData.token },
                          })
                            .then((areaRes) => {
                              const aList = areaRes.data?.message || [];
                              setEditAreaList(aList);

                              const matchedAId = matchIdInList(aList, user.areaId, user.area);
                              setEditArea(matchedAId);
                              setInitialArea(matchedAId);
                            })
                            .catch(() => setEditAreaList([]));
                        }
                      })
                      .catch(() => setEditSubdivList([]));
                  }
                })
                .catch(() => setEditDivisionList([]));
            }
          })
          .catch(() => setEditCircleList([]));
      } else if (!matchedWingId && needsSubdiv) {
        const divForSub = user.divisionId || userData?.divId;
        if (divForSub) {
          axios({
            method: "GET",
            url: `${baseurl}/api/get/list?field=subDivision&userId=${userData.userId}&isSortingRequired=2`,
            params: { divisionId: divForSub, isSortingRequired: 2 },
            headers: { Authorization: "Bearer " + userData.token },
          })
            .then((subRes) => {
              const sList = subRes.data?.message || [];
              setEditSubdivList(sList);
              const matchedSubId = matchIdInList(sList, user.subDivisionId, user.subDivision);
              setEditSubdiv(matchedSubId);
              setInitialSubdiv(matchedSubId);

              if (matchedSubId && needsArea) {
                axios({
                  method: "GET",
                  url: `${baseurl}/api/get/list?field=area&userId=${userData.userId}&isSortingRequired=2`,
                  params: { subDivisionId: matchedSubId, isSortingRequired: 2 },
                  headers: { Authorization: "Bearer " + userData.token },
                })
                  .then((areaRes) => {
                    const aList = areaRes.data?.message || [];
                    setEditAreaList(aList);
                    const matchedAId = matchIdInList(aList, user.areaId, user.area);
                    setEditArea(matchedAId);
                    setInitialArea(matchedAId);
                  })
                  .catch(() => setEditAreaList([]));
              }
            })
            .catch(() => setEditSubdivList([]));
        }
      }

      if (wList.length === 0) {
        axios({
          method: "POST",
          url: `${baseurl}/api/regions/hierarchy?userId=${userData.userId}&isSortingRequired=2`,
          headers: { Authorization: "Bearer " + userData.token },
          data: baseHierarchyBody(),
        })
          .then((hRes) => {
            if (hRes.data?.wingList) {
              setEditWingList(hRes.data.wingList);
              if (!matchedWingId) {
                const retryWingId = matchIdInList(hRes.data.wingList, user.wingId, user.wing);
                if (retryWingId) {
                  setEditWing(retryWingId);
                  setInitialWing(retryWingId);
                }
              }
            }
          })
          .catch(() => {});
      }
    }

    setEditModal(true);
  };

  const handleCloseEdit = () => {
    if (isEditing) return;
    setEditModal(false);
    setEditUser(null);
    setEditErrors({});
    setEditSubmitErr("");
    setEditWing("");
    setInitialWing("");
    setEditWingList([]);
    setEditCircle("");
    setInitialCircle("");
    setEditCircleList([]);
    setEditDivision("");
    setInitialDivision("");
    setEditDivisionList([]);
    setEditSubdiv("");
    setInitialSubdiv("");
    setEditSubdivList([]);
    setEditArea("");
    setInitialArea("");
    setEditAreaList([]);
    setInitialEditData({});
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    let val = value;
    if (name === "contactNumber") {
      val = val.replace(/[^0-9]/g, "").slice(0, 10);
    } else if (name === "name") {
      val = val.replace(/^\s+/, "").slice(0, 50);
    } else if (name === "designation" || name === "location") {
      val = val.slice(0, 100);
    }
    setEditData((prev) => ({ ...prev, [name]: val }));
    setEditSubmitErr("");

    const errors = { ...editErrors };
    if (name === "name") {
      if (!val || val.trim() === "") {
        errors.name = "Please Enter Valid Name";
      } else {
        delete errors.name;
      }
    }
    if (name === "contactNumber") {
      if (!val || val.trim() === "") {
        errors.contactNumber = "Please enter a valid 10-digit number";
      } else if (!/^[0-9]+$/.test(val)) {
        errors.contactNumber = "Enter numbers only";
      } else if (!/^[6-9]/.test(val)) {
        errors.contactNumber = "Contact number must start with 6, 7, 8, or 9";
      } else if (val.length !== 10) {
        errors.contactNumber = "Please enter a valid 10-digit number";
      } else {
        delete errors.contactNumber;
      }
    }
    if (name === "designation") {
      if (val && val.trim() === "") {
        errors.designation = "Spaces alone are not allowed";
      } else {
        delete errors.designation;
      }
    }
    if (name === "location") {
      if (val && val.trim() === "") {
        errors.location = "Spaces alone are not allowed";
      } else {
        delete errors.location;
      }
    }
    setEditErrors(errors);
  };

  const handleEditWingChange = (e) => {
    const newWingId = e.target.value;
    setEditWing(newWingId);
    setEditCircle("");
    setEditDivision("");
    setEditSubdiv("");
    setEditArea("");
    setEditCircleList([]);
    setEditDivisionList([]);
    setEditSubdivList([]);
    setEditAreaList([]);

    const uRole = String(editUser?.role || "").trim().toUpperCase();
    const needsCircle = ["SE", "DE", "ADE", "AE"].includes(uRole);

    if (newWingId && needsCircle) {
      axios({
        method: "GET",
        url: `${baseurl}/api/get/list?field=circle&wingId=${newWingId}&userId=${userData.userId}&isSortingRequired=2`,
        headers: { Authorization: "Bearer " + userData.token },
      })
        .then((res) => {
          setEditCircleList(res.data?.message || []);
        })
        .catch(() => setEditCircleList([]));
    }
  };

  const handleEditCircleChange = (e) => {
    const newCircleId = e.target.value;
    setEditCircle(newCircleId);
    setEditDivision("");
    setEditSubdiv("");
    setEditArea("");
    setEditDivisionList([]);
    setEditSubdivList([]);
    setEditAreaList([]);

    const uRole = String(editUser?.role || "").trim().toUpperCase();
    const needsDivision = ["DE", "ADE", "AE"].includes(uRole);

    if (newCircleId && needsDivision) {
      axios({
        method: "GET",
        url: `${baseurl}/api/get/list?field=division&circleId=${newCircleId}&userId=${userData.userId}&isSortingRequired=2`,
        params: { circleId: newCircleId, isSortingRequired: 2 },
        headers: { Authorization: "Bearer " + userData.token },
      })
        .then((res) => {
          setEditDivisionList(res.data?.message || []);
        })
        .catch(() => setEditDivisionList([]));
    }
  };

  const handleEditDivisionChange = (e) => {
    const newDivisionId = e.target.value;
    setEditDivision(newDivisionId);
    setEditSubdiv("");
    setEditArea("");
    setEditSubdivList([]);
    setEditAreaList([]);

    const uRole = String(editUser?.role || "").trim().toUpperCase();
    const needsSubdiv = ["ADE", "AE"].includes(uRole);

    if (newDivisionId && needsSubdiv) {
      axios({
        method: "GET",
        url: `${baseurl}/api/get/list?field=subDivision&divisionId=${newDivisionId}&userId=${userData.userId}&isSortingRequired=2`,
        params: { divisionId: newDivisionId, isSortingRequired: 2 },
        headers: { Authorization: "Bearer " + userData.token },
      })
        .then((res) => {
          setEditSubdivList(res.data?.message || []);
        })
        .catch(() => setEditSubdivList([]));
    }
  };

  const handleEditSubdivChange = (e) => {
    const newSubdivId = e.target.value;
    setEditSubdiv(newSubdivId);
    setEditArea("");
    setEditAreaList([]);

    const uRole = String(editUser?.role || "").trim().toUpperCase();
    const needsArea = uRole === "AE";

    if (newSubdivId && needsArea) {
      axios({
        method: "GET",
        url: `${baseurl}/api/get/list?field=area&subDivisionId=${newSubdivId}&userId=${userData.userId}&isRoleBasedDataRequired=1&isSortingRequired=2`,
        params: { subDivisionId: newSubdivId },
        headers: { Authorization: "Bearer " + userData.token },
      })
        .then((res) => {
          setEditAreaList(res.data?.message || []);
        })
        .catch(() => {
          setEditAreaList([]);
        });
    }
  };

  const handleUpdateUser = (e) => {
    if (e) e.preventDefault();
    if (!editUser) return;

    const userId = editUser.id != null ? editUser.id : editUser.userId;
    if (!userId) {
      setMessageList("User ID not found");
      setShowToast(true);
      return;
    }

    const baseInitial = initialEditData || {};
    const isNameChanged =
      (editData.name || "").trim() !== (baseInitial.name || "").trim();
    const isContactChanged =
      (editData.contactNumber || "").trim() !==
      (baseInitial.contactNumber || "").trim();
    const isDesignationChanged =
      (editData.designation || "").trim() !==
      (baseInitial.designation || "").trim();
    const isLocationChanged =
      (editData.location || "").trim() !== (baseInitial.location || "").trim();
    const isLockedChanged = editData.isLocked !== baseInitial.isLocked;
    const isActiveStatusChanged = editData.activeStatus !== baseInitial.activeStatus;

    const uRole = String(editUser?.role || "").trim().toUpperCase();
    const needsWing = ["CE", "SE", "DE", "ADE", "AE"].includes(uRole);
    const needsCircle = ["SE", "DE", "ADE", "AE"].includes(uRole);
    const needsDivision = ["DE", "ADE", "AE"].includes(uRole);
    const needsSubdiv = ["ADE", "AE"].includes(uRole);
    const needsArea = uRole === "AE";

    const isWingChanged = needsWing && String(editWing || "") !== String(initialWing || "");
    const isCircleChanged = needsCircle && String(editCircle || "") !== String(initialCircle || "");
    const isDivisionChanged = needsDivision && String(editDivision || "") !== String(initialDivision || "");
    const isSubdivChanged = needsSubdiv && String(editSubdiv || "") !== String(initialSubdiv || "");
    const isAreaChanged = needsArea && String(editArea || "") !== String(initialArea || "");

    const hasChanges =
      isNameChanged ||
      isContactChanged ||
      isDesignationChanged ||
      isLocationChanged ||
      isLockedChanged ||
      isActiveStatusChanged ||
      isWingChanged ||
      isCircleChanged ||
      isDivisionChanged ||
      isSubdivChanged ||
      isAreaChanged;

    if (!hasChanges) {
      setMessageList("No changes made to update");
      setShowToast(true);
      setEditSubmitErr("No changes made to update");
      return;
    }

    const errors = {};
    if (!editData.name || editData.name.trim() === "") {
      errors.name = "Please Enter Valid Name";
    }
    if (!editData.contactNumber || editData.contactNumber.trim() === "") {
      errors.contactNumber = "Please enter a valid 10-digit number";
    } else if (!/^[6-9][0-9]{9}$/.test(editData.contactNumber)) {
      errors.contactNumber = !/^[6-9]/.test(editData.contactNumber)
        ? "Contact number must start with 6, 7, 8, or 9"
        : "Please enter a valid 10-digit number";
    }
    if (editData.designation && editData.designation.trim() === "") {
      errors.designation = "Spaces alone are not allowed";
    }
    if (editData.location && editData.location.trim() === "") {
      errors.location = "Spaces alone are not allowed";
    }

    if (Object.keys(errors).length > 0) {
      setEditErrors(errors);
      return;
    }

    const payload = {
      name: editData.name.trim(),
      contactNumber: editData.contactNumber.trim(),
      designation: editData.designation ? editData.designation.trim() : "",
      location: editData.location ? editData.location.trim() : "",
      isLocked: editData.isLocked === 1 ? 1 : 0,
      activeStatus: editData.activeStatus === 1 ? 1 : 0,
    };

    if (needsWing && isWingChanged && editWing && !isNaN(parseInt(editWing, 10))) {
      payload.wing = parseInt(editWing, 10);
    }
    if (needsCircle && isCircleChanged && editCircle && !isNaN(parseInt(editCircle, 10))) {
      payload.circle = parseInt(editCircle, 10);
    }
    if (needsDivision && isDivisionChanged && editDivision && !isNaN(parseInt(editDivision, 10))) {
      payload.division = parseInt(editDivision, 10);
    }
    if (needsSubdiv && isSubdivChanged && editSubdiv && !isNaN(parseInt(editSubdiv, 10))) {
      payload.subDivision = parseInt(editSubdiv, 10);
    }
    if (needsArea && isAreaChanged && editArea && !isNaN(parseInt(editArea, 10))) {
      payload.area = parseInt(editArea, 10);
    }

    setIsEditing(true);
    setEditSubmitErr("");
    axios({
      method: "PUT",
      url: `${baseurl}/api/user/edit/${userId}`,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userData.token,
      },
    })
      .then((response) => {
        const msg =
          response.data?.message || "User details updated successfully...";
        setSuccesstoastmsg(msg);
        setSuccesstoastmsgstatus(true);
        setEditModal(false);
        setEditUser(null);
        fetchUsers(currentPage, buildFilters(formData))
          .then(applyUsers)
          .catch(() => setisLoading(false));
      })
      .catch((error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
          if (error.response?.data?.message) {
            setTokenMsg(error.response.data.message);
          } else {
            setTokenMsg(error.response.status);
          }
        }
        const msg = error.response?.data?.message || "Failed to update user";
        setEditSubmitErr(msg);
        setMessageList(msg);
        setShowToast(true);
      })
      .finally(() => {
        setIsEditing(false);
      });
  };

  const handleOpenDelete = (user) => {
    setUserToDelete(user);
    setDeleteModal(true);
  };

  const handleCloseDelete = () => {
    if (isDeleting) return;
    setDeleteModal(false);
    setUserToDelete(null);
  };

  const handleDeleteUser = () => {
    if (!userToDelete) return;
    const userId =
      userToDelete.id != null ? userToDelete.id : userToDelete.userId;
    if (!userId) {
      setMessageList("User ID not found");
      setShowToast(true);
      return;
    }

    setIsDeleting(true);
    axios({
      method: "DELETE",
      url: `${baseurl}/api/user/delete/${userId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userData.token,
      },
    })
      .then((response) => {
        const msg = response.data?.message || "User deleted successfully...";
        setSuccesstoastmsg(msg);
        setSuccesstoastmsgstatus(true);
        setDeleteModal(false);
        setUserToDelete(null);
        fetchUsers(currentPage, buildFilters(formData))
          .then(applyUsers)
          .catch(() => setisLoading(false));
      })
      .catch((error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
          if (error.response?.data?.message) {
            setTokenMsg(error.response.data.message);
          } else {
            setTokenMsg(error.response.status);
          }
        }
        const msg = error.response?.data?.message || "Failed to delete user";
        setMessageList(msg);
        setShowToast(true);
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };

  const handleExportToExcel = () => {
    axios({
      method: "POST",
      url: baseurl + "/api/user/export/excel?userId=" + userData.userId,
      headers: authHeaders,
      responseType: "blob",
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "User List.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  /* ---------------- drawer behaviour ---------------- */

  const activeFilterCount = Object.values(formData).filter(Boolean).length;

  useEffect(() => {
    if (!showFilters) return;
    const onKey = (e) => e.key === "Escape" && setShowFilters(false);
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = previous;
      document.removeEventListener("keydown", onKey);
    };
  }, [showFilters]);

  useEffect(() => {
    if (isDesktop) setShowFilters(false);
  }, [isDesktop]);

  function xlDownload() {
    axios({
      method: "GET",
      url: baseurl + "/api/download-user-template?userId=" + userData.userId,
      headers: authHeaders,
      responseType: "blob",
    })
      .then((response) => {
        let filename = "User Creation Template.xlsx";
        const contentDisposition = response.headers["content-disposition"];
        const filenameMatch =
          contentDisposition?.match(/filename="?([^"]+)"?/);
        if (filenameMatch?.[1]) filename = filenameMatch[1];

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.error(err);
      });
  }
  const renderFilterPanel = ({ drawer = false } = {}) => (
    <>
      {!drawer && (
        <div className="p-2 d-flex justify-content-between align-items-center text-white longhand ">
          <p className="mb-0">Filter</p>
          <button
            className="mb-0 border px-2 pointerborder"
            onClick={handleRemoveFilter}
          >
            Remove
          </button>
        </div>
      )}
      <div className="px-2 pb-2 pt-0 border">
        {FILTER_CARDS.filter(
          (card) => !card.adminOnly || userData.role === "Admin",
        ).map(({ region, person }) => (
          <div className="filter-card" key={region.key}>
            <div>
              <div>
                <div className="d-flex align-items-center mb-1">
                  <h6 className="mb-0 ml-1">{region.label}</h6>
                </div>
                <select
                  value={formData[region.key] ? formData[region.key].name : ""}
                  onChange={handleSelectChange}
                  name={region.key}
                  className="form-control"
                >
                  <option value="">{region.label}</option>
                  {(optionsByKey[region.key] || []).map((item, index) => (
                    <option key={`${item.name}-${index}`} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mt-1">
                <h6>{person.label}</h6>
                <select
                  value={formData[person.key] ? formData[person.key].name : ""}
                  onChange={handleSelectChange}
                  name={person.key}
                  className="form-control"
                >
                  <option value="" disabled>
                    {person.label}
                  </option>
                  {(optionsByKey[person.key] || []).map((item, index) => (
                    <option key={`${item.name}-${index}`}>{item.name}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  const editRole = String(editUser?.role || "").trim().toUpperCase();
  const isEditCe = editRole === "CE";
  const isEditSe = editRole === "SE";
  const isEditDe = editRole === "DE";
  const isEditAde = editRole === "ADE";
  const isEditAe = editRole === "AE";

  const showEditWing =
    isEditCe || isEditSe || isEditDe || isEditAde || isEditAe;

  const showEditCircle =
    isEditSe || isEditDe || isEditAde || isEditAe;

  const showEditDivision =
    isEditDe || isEditAde || isEditAe;

  const showEditSubdiv =
    isEditAde || isEditAe;

  const showEditArea =
    isEditAe;

  const renderLoadingOverlay = () => (
    <div className="overlay-loading-div2 d-flex justify-content-center align-items-center">
      <ThreeDots
        visible={true}
        height="50"
        width="100"
        color="#3369a6"
        radius="7"
        ariaLabel="three-dots-loading"
      />
    </div>
  );

  return (
    <>
      <LogoutComponent tokenExpirationMsg={tokenMsg} />
      {isCreatingUser &&
        (typeof document !== "undefined"
          ? createPortal(renderLoadingOverlay(), document.body)
          : renderLoadingOverlay())}
      {isUploadingFile &&
        (typeof document !== "undefined"
          ? createPortal(renderLoadingOverlay(), document.body)
          : renderLoadingOverlay())}

      <div className="user-page mx-md-4 core-zoom">

      {/* Toolbar */}
      <div className="master-toolbar mb-1">
        {/* Filter trigger (below lg) */}
        <button
          type="button"
          className="btn shadow text-white d-inline-flex align-items-center custom-btn-user-style d-lg-none master-filter-trigger w-auto"
          onClick={() => setShowFilters(true)}
          aria-label="Open filters"
        >
          <RiFilter2Fill className="font20" />
          <span className="d-none d-sm-inline">Filter</span>
          {activeFilterCount > 0 && (
            <span className="master-filter-count">{activeFilterCount}</span>
          )}
        </button>

        {/* md and up: action buttons */}
        <div className="master-actions d-none d-md-flex">
          <button
            onClick={requestdata1}
            type="button"
            title="Create New Userlist"
            aria-label="Create New Userlist"
            className="btn shadow text-white d-inline-flex align-items-center btn-success w-auto fsi-12"
          >
            <IoPeopleOutline size={18} />
            <span className="d-none d-md-block">Create User</span>
          </button>


          <button
            type="button"
            title="Download Template"
            aria-label="Download Template"
            onClick={() => xlDownload()}
            className="btn shadow text-white d-inline-flex align-items-center custom-btn-user-style w-auto"
          >
            <HiOutlineDownload className="font20" />
            <span className="d-none d-md-block">User Template</span>
          </button>


          <button
            onClick={handleExportToExcel}
            type="button"
            title="Export Data"
            aria-label="Export Data"
            className="btn shadow text-white d-inline-flex align-items-center custom-btn-user-style w-auto"
          >
            <TbFileExport className="font20" />
            <span className="d-none d-md-block">Export</span>
          </button>

          {!rolestatus && (
            <>
              <button
                type="button"
                title="Upload File"
                aria-label="Upload File"
                className="container-btn-file font12"
              >
                <ExcelIcon />
                <span className="d-none d-md-block">User Upload</span>
                <input
                  className="file"
                  name="text"
                  type="file"
                  onChange={handleFileUpload}
                />
              </button>
              {fileErr && (
                <span className="text-danger mb-0 mt-2 text-center">
                  {fileErr}
                </span>
              )}
            </>
          )}
        </div>

        {/* Below md: the same actions in one dropdown */}
        <Dropdown align="end" className="d-md-none ms-auto">
          <Dropdown.Toggle
            as="button"
            bsPrefix="master-actions-toggle"
            type="button"
            aria-label="More actions"
            className="btn shadow text-white d-inline-flex align-items-center justify-content-center custom-btn-user-style w-auto"
          >
            Actions
          </Dropdown.Toggle>

          <Dropdown.Menu className="master-actions-menu">
            <Dropdown.Item
              as="button"
              type="button"
              onClick={requestdata1}
              className="master-actions-item"
            >
              <IoPeopleOutline size={18} /> Create User
            </Dropdown.Item>

            <Dropdown.Divider />

            <Dropdown.Item
              as="button"
              type="button"
              onClick={xlDownload}
              className="master-actions-item"
            >
              <HiOutlineDownload size={18} /> User Template
            </Dropdown.Item>

            <Dropdown.Item
              as="button"
              type="button"
              onClick={handleExportToExcel}
              className="master-actions-item"
            >
              <TbFileExport size={18} /> Export 
            </Dropdown.Item>

            {!rolestatus && (
              <Dropdown.Item
                as="button"
                type="button"
                onClick={() => fileInputRef.current?.click()}
                className="master-actions-item"
              >
                <ExcelIcon fill="currentColor" size={16} /> User Upload
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>

        {/* Always mounted so the file picker still works after the menu closes */}
        <input
          ref={fileInputRef}
          type="file"
          className="d-none"
          onChange={handleFileUpload}
        />
      </div>

      {successtoastmsgstatus && successtoastmsg != "" && (
        <CustomSuccessToastContainer
          message={successtoastmsg}
          onClose={ToclosesuccessToast}
          show={successtoastmsgstatus}
        />
      )}

      {showToast && messageList != "" && (
        <CustomErrorToastContainer
          message={messageList}
          onClose={TocloseToast1}
          show={showToast}
        />
      )}

      <div className="row user-page-body ">
        {/* Sidebar filters (large screens) */}
        <div className="col-lg-3 d-none d-lg-block user-filter-col">
          {renderFilterPanel()}
        </div>

        {/* User cards */}
        <div className="col-lg-9 col-12 user-results-col">
          <div>
            {!isLoading && (renewallist || []).length === 0 && (
              <div className="text-center py-5 login-error">
                <b>
                  <h6>No data found</h6>
                </b>
              </div>
            )}
            {(renewallist || []).map((item, index) => (
              <div className="user-card uc" key={`${item.name}-${index}`}>
                {/* Header */}
                <div className="uc-header">
                  {item.role && (
                    <span
                      className={`uc-role ${roleSizeClass(item.role)}`}
                      title={item.role}
                    >
                      {item.role}
                    </span>
                  )}

                  <div className="uc-title">
                    <h6 className="uc-name text-break">{item.name}</h6>
                    <span className="uc-designation">
                      {item.designation || "-"}
                    </span>
                  </div>

                  <div className="uc-badges align-items-center">
                    {item.status && (
                      <span className={`uc-status ${statusClass(item.status)}`}>
                        <i className="uc-dot" />
                        {item.status}
                      </span>
                    )}
                    <div className="uc-actions">
                      <button
                        type="button"
                        className="uc-action-btn"
                        onClick={() => handleOpenEdit(item)}
                        title="Edit User"
                      >
                        <BiEditAlt color="green" size={18} />
                      </button>
                      <button
                        type="button"
                        className="uc-action-btn"
                        onClick={() => handleOpenDelete(item)}
                        title="Delete User"
                      >
                        <BiTrash color="red" size={18} />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Details */}
                <div className="uc-body">
                  <Detail
                    icon={<IoMailOutline />}
                    label="E-mail"
                    title={item.email}
                  >
                    {item.email}
                  </Detail>
                  <Detail icon={<IoCallOutline />} label="Phone">
                    {item.contactNumber}
                  </Detail>
                  <Detail icon={<IoGitNetworkOutline />} label="Reports to">
                    {item.reportTo}
                  </Detail>
                  <Detail icon={<IoPersonOutline />} label="Reported by">
                    {item.reportBy}
                  </Detail>
                  <Detail
                    icon={<IoLocationOutline />}
                    label="Location"
                    title={item.location}
                  >
                    {item.location}
                  </Detail>
                </div>

                {/* Regions */}
                {String(item.role || "").trim().toLowerCase() !== "admin" && (
                  <div className="uc-regions">
                    <RegionChip
                      label="Wing"
                      values={resolveRegionValues(item, [
                        "wingList",
                        "wingsList",
                        "wings",
                        "wing",
                      ])}
                    />
                    <RegionChip
                      label="Circle"
                      values={resolveRegionValues(item, [
                        "circleList",
                        "circlesList",
                        "circles",
                        "circle",
                      ])}
                    />
                    <RegionChip
                      label="Division"
                      values={resolveRegionValues(item, [
                        "divisionList",
                        "divisionsList",
                        "divisions",
                        "division",
                      ])}
                    />
                    <RegionChip
                      label="Subdivision"
                      values={resolveRegionValues(item, [
                        "subDivisionList",
                        "subdivisionList",
                        "subDivisions",
                        "subdivisions",
                        "subDivision",
                        "subdivision",
                      ])}
                    />
                    <RegionChip
                      label="Area"
                      values={resolveRegionValues(item, [
                        "areaList",
                        "areasList",
                        "areas",
                        "area",
                      ])}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>

          {isLoading && (
            <div className="d-flex justify-content-center w-100 mt-5 pt-5">
              <ThreeDots
                visible={true}
                height="20"
                width="40"
                color="#3369a6"
                radius="7"
                ariaLabel="three-dots-loading"
              />
            </div>
          )}
        </div>
      </div>

      {renewallist && renewallist.length != 0 && (
        <div className="user-pagination w-100 d-flex justify-content-center justify-content-md-end">
          <ReactPaginate
            breakLabel="..."
            nextLabel={<GrFormNext />}
            onPageChange={handlePageClick}
            pageRangeDisplayed={isPhone ? 1 : 3}
            marginPagesDisplayed={isPhone ? 1 : 2}
            pageCount={totalpageno}
            previousLabel={<GrFormPrevious />}
            renderOnZeroPageCount={null}
            containerClassName="pagination m-0"
            activeClassName="active"
          />
        </div>
      )}

      {/* Filter drawer (below lg) */}
      <AnimatePresence>
        {showFilters && (
          <motion.div
            key="filter-backdrop"
            className="filter-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={() => setShowFilters(false)}
          />
        )}
        {showFilters && (
          <motion.aside
            key="filter-drawer"
            className="filter-drawer"
            role="dialog"
            aria-modal="true"
            aria-label="Filters"
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ type: "tween", duration: 0.25 }}
          >
            <div className="filter-drawer-header">
              <strong>Filter</strong>
              <div className="d-flex align-items-center gap-2">
                <button
                  type="button"
                  className="btn p-1 border subtle-text-style"
                  onClick={handleRemoveFilter}
                >
                  Remove
                </button>
                <button
                  type="button"
                  className="btn px-2 py-0"
                  aria-label="Close filters"
                  onClick={() => setShowFilters(false)}
                >
                  <IoClose size={20} />
                </button>
              </div>
            </div>

            <div className="filter-drawer-body">
              {renderFilterPanel({ drawer: true })}
            </div>

          </motion.aside>
        )}
      </AnimatePresence>




      {/* Edit user modal */}
      {editModal && editUser && (
        <Modal
          show={editModal}
          size="lg"
          centered
          className="user-modal"
          onHide={handleCloseEdit}
        >
          <Modal.Body className="bg-white">
            <div className="d-flex mb-3 align-items-center justify-content-between">
              <h6 className="mb-0">Edit User</h6>
              <button
                type="button"
                className="btn btn-sm font20"
                onClick={handleCloseEdit}
                disabled={isEditing}
              >
                <IoClose />
              </button>
            </div>
            <hr className="my-2" />
            <form className="circlediv" autoComplete="off" onSubmit={handleUpdateUser}>
              <div className="w-100 row mx-auto pt-3 mt-2 borderradius">
                {/* Name */}
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                  <div className="field-row d-flex justify-content-between align-items-center">
                    <label className="login-text mb-0 d-inline-flex align-items-center">
                      <b className="font12">Name</b>
                      <span className="text-danger ml-1">*</span>
                    </label>
                    <InputTextField
                      inputId="edit-name"
                      inputName="name"
                      fieldName="name"
                      valueText={editData.name}
                      handleInputChange={handleEditInputChange}
                      inputType="text"
                      classname="project-box pl-2 w-50 font12"
                      placeholderValue="Enter Name"
                      maxLen={50}
                    />
                  </div>
                  {editErrors.name && (
                    <div className="text-right">
                      <span className="text-danger font12">{editErrors.name}</span>
                    </div>
                  )}
                </div>

                {/* Contact Number */}
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                  <div className="field-row d-flex justify-content-between align-items-center">
                    <label className="login-text mb-0 d-inline-flex align-items-center">
                      <b className="font12">Contact Number</b>
                      <span className="text-danger ml-1">*</span>
                    </label>
                    <InputTextField
                      inputId="edit-contactNumber"
                      inputName="contactNumber"
                      fieldName="contactNumber"
                      valueText={editData.contactNumber}
                      handleInputChange={handleEditInputChange}
                      inputType="text"
                      classname="project-box pl-2 w-50 font12"
                      placeholderValue="Enter Contact Number"
                      maxLen={10}
                    />
                  </div>
                  {editErrors.contactNumber && (
                    <div className="text-right">
                      <span className="text-danger font12">{editErrors.contactNumber}</span>
                    </div>
                  )}
                </div>

                {/* Designation */}
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                  <div className="field-row d-flex justify-content-between align-items-center">
                    <label className="login-text mb-0 d-inline-flex align-items-center">
                      <b className="font12">Designation</b>
                    </label>
                    <InputTextField
                      inputId="edit-designation"
                      inputName="designation"
                      fieldName="designation"
                      valueText={editData.designation}
                      handleInputChange={handleEditInputChange}
                      inputType="text"
                      classname="project-box pl-2 w-50 font12"
                      placeholderValue="Enter Designation"
                      maxLen={100}
                    />
                  </div>
                  {editErrors.designation && (
                    <div className="text-right">
                      <span className="text-danger font12">{editErrors.designation}</span>
                    </div>
                  )}
                </div>

                {/* Location */}
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                  <div className="field-row d-flex justify-content-between align-items-center">
                    <label className="login-text mb-0 d-inline-flex align-items-center">
                      <b className="font12">Location</b>
                    </label>
                    <InputTextField
                      inputId="edit-location"
                      inputName="location"
                      fieldName="location"
                      valueText={editData.location}
                      handleInputChange={handleEditInputChange}
                      inputType="text"
                      classname="project-box pl-2 w-50 font12"
                      placeholderValue="Enter Location"
                      maxLen={100}
                    />
                  </div>
                  {editErrors.location && (
                    <div className="text-right">
                      <span className="text-danger font12">{editErrors.location}</span>
                    </div>
                  )}
                </div>

                {/* Active Status */}
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                  <div className="field-row d-flex justify-content-between align-items-center">
                    <label className="login-text mb-0 d-inline-flex align-items-center">
                      <b className="font12">Active Status</b>
                    </label>
                    <div className="w-50 d-flex align-items-center">
                      <label
                        htmlFor="edit-activeStatus"
                        className="user-checkbox-label d-inline-flex align-items-center mb-0"
                      >
                        <input
                          type="checkbox"
                          id="edit-activeStatus"
                          name="activeStatus"
                          className="user-checkbox-input"
                          checked={editData.activeStatus === 1}
                          onChange={(e) => {
                            const val = e.target.checked ? 1 : 0;
                            setEditData((prev) => ({ ...prev, activeStatus: val }));
                            setEditSubmitErr("");
                          }}
                        />
                        <span
                          className={`font12 font-weight-bold user-checkbox-text ${
                            editData.activeStatus === 1 ? "text-success" : "text-muted"
                          }`}
                        >
                          {editData.activeStatus === 1 ? "Active" : "Inactive"}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                {/* Account Lock */}
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                  <div className="field-row d-flex justify-content-between align-items-center">
                    <label className="login-text mb-0 d-inline-flex align-items-center">
                      <b className="font12">Account Lock</b>
                    </label>
                    <div className="w-50 d-flex align-items-center">
                      <label
                        htmlFor="edit-isLocked"
                        className="user-checkbox-label d-inline-flex align-items-center mb-0"
                      >
                        <input
                          type="checkbox"
                          id="edit-isLocked"
                          name="isLocked"
                          className="user-checkbox-input"
                          checked={editData.isLocked === 1}
                          onChange={(e) => {
                            const val = e.target.checked ? 1 : 0;
                            setEditData((prev) => ({ ...prev, isLocked: val }));
                            setEditSubmitErr("");
                          }}
                        />
                        <span
                          className={`font12 font-weight-bold user-checkbox-text ${
                            editData.isLocked === 1 ? "text-danger" : "text-success"
                          }`}
                        >
                          {editData.isLocked === 1 ? "Locked" : "Unlocked"}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                {/* Wing */}
                {showEditWing && (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                    <div className="field-row d-flex justify-content-between align-items-center">
                      <label htmlFor="edit-wing-select" className="login-text mb-0 d-inline-flex align-items-center">
                        <PiRoadHorizonBold className="blueblue mr-1" />
                        <b className="font12">Choose Wing</b>
                        <span className="text-danger ml-1">*</span>
                      </label>
                      <select
                        id="edit-wing-select"
                        className="project-box w-50 font12"
                        value={editWing}
                        onChange={handleEditWingChange}
                      >
                        <option value="">Select Wing</option>
                        {editWing &&
                          !editWingList.some((item) => String(item.id) === String(editWing)) && (
                            <option value={editWing}>
                              {Array.isArray(editUser.wing)
                                ? editUser.wing.join(", ")
                                : editUser.wing || editWing}
                            </option>
                          )}
                        {editWingList.map((item, idx) => (
                          <option key={item.id ?? idx} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                {/* Circle */}
                {showEditCircle && (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                    <div className="field-row d-flex justify-content-between align-items-center">
                      <label htmlFor="edit-circle-select" className="login-text mb-0 d-inline-flex align-items-center">
                        <i className="ri-apps-2-add-fill rotated-text mr-1"></i>
                        <b className="font12">Choose Circle</b>
                        <span className="text-danger ml-1">*</span>
                      </label>
                      <select
                        id="edit-circle-select"
                        className="project-box w-50 font12"
                        value={editCircle}
                        onChange={handleEditCircleChange}
                      >
                        <option value="">Select Circle</option>
                        {editCircle &&
                          !editCircleList.some((item) => String(item.id) === String(editCircle)) && (
                            <option value={editCircle}>
                              {Array.isArray(editUser.circle)
                                ? editUser.circle.join(", ")
                                : editUser.circle || editCircle}
                            </option>
                          )}
                        {editCircleList.map((item, idx) => (
                          <option key={item.id ?? idx} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                {/* Division */}
                {showEditDivision && (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                    <div className="field-row d-flex justify-content-between align-items-center">
                      <label htmlFor="edit-division-select" className="login-text mb-0 d-inline-flex align-items-center">
                        <IoIosBrowsers className="blueblue mr-1" />
                        <b className="font12">Choose Division</b>
                        <span className="text-danger ml-1">*</span>
                      </label>
                      <select
                        id="edit-division-select"
                        className="project-box w-50 font12"
                        value={editDivision}
                        onChange={handleEditDivisionChange}
                      >
                        <option value="">Select Division</option>
                        {editDivision &&
                          !editDivisionList.some((item) => String(item.id) === String(editDivision)) && (
                            <option value={editDivision}>
                              {Array.isArray(editUser.division)
                                ? editUser.division.join(", ")
                                : editUser.division || editDivision}
                            </option>
                          )}
                        {editDivisionList.map((item, idx) => (
                          <option key={item.id ?? idx} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                {/* SubDivision */}
                {showEditSubdiv && (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                    <div className="field-row d-flex justify-content-between align-items-center">
                      <label htmlFor="edit-subdiv-select" className="login-text mb-0 d-inline-flex align-items-center">
                        <PiChartPieSliceFill className="blueblue mr-1" />
                        <b className="font12">Choose SubDivision</b>
                        <span className="text-danger ml-1">*</span>
                      </label>
                      <select
                        id="edit-subdiv-select"
                        className="project-box w-50 font12"
                        value={editSubdiv}
                        onChange={handleEditSubdivChange}
                      >
                        <option value="">Select SubDivision</option>
                        {editSubdiv &&
                          !editSubdivList.some((item) => String(item.id) === String(editSubdiv)) && (
                            <option value={editSubdiv}>
                              {Array.isArray(editUser.subDivision)
                                ? editUser.subDivision.join(", ")
                                : editUser.subDivision || editSubdiv}
                            </option>
                          )}
                        {editSubdivList.map((item, idx) => (
                          <option key={item.id ?? idx} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {editErrors.subDivision && (
                      <div className="text-right">
                        <span className="text-danger font12">{editErrors.subDivision}</span>
                      </div>
                    )}
                  </div>
                )}

                {/* Area */}
                {showEditArea && (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                    <div className="field-row d-flex justify-content-between align-items-center">
                      <label htmlFor="edit-area-select" className="login-text mb-0 d-inline-flex align-items-center">
                        <PiUserCircleFill className="blueblue mr-1" />
                        <b className="font12">Choose Area</b>
                        <span className="text-danger ml-1">*</span>
                      </label>
                      <select
                        id="edit-area-select"
                        className="project-box w-50 font12"
                        value={editArea}
                        onChange={(e) => setEditArea(e.target.value)}
                      >
                        <option value="">Select Area</option>
                        {editArea &&
                          !editAreaList.some((item) => String(item.id) === String(editArea)) && (
                            <option value={editArea}>
                              {Array.isArray(editUser.area)
                                ? editUser.area.join(", ")
                                : editUser.area || editArea}
                            </option>
                          )}
                        {editAreaList.map((item, idx) => (
                          <option key={item.id ?? idx} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {editErrors.area && (
                      <div className="text-right">
                        <span className="text-danger font12">{editErrors.area}</span>
                      </div>
                    )}
                  </div>
                )}

                {/* Submit button */}
                <div className="col-sm-12 col-lg-12 col-12 col-md-12 col-xl-12 mt-3">
                  <div className="text-center w-100">
                    <button
                      type="button"
                      className="user-modal-submit-btn mx-auto"
                      onClick={handleUpdateUser}
                      disabled={isEditing}
                    >
                      {isEditing ? "Updating..." : "Update"}
                    </button>
                  </div>
                  {editSubmitErr && (
                    <p className="text-danger text-center mb-0 mt-2 font12 font-weight-bold">
                      {editSubmitErr}
                    </p>
                  )}
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      )}

      {/* Delete user confirmation modal */}
      {deleteModal && userToDelete && (
        <Modal
          show={deleteModal}
          centered
          onHide={handleCloseDelete}
          className="user-modal"
          size="sm"
        >
          <Modal.Body className="bg-white p-3">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h6 className="mb-0 text-danger font-weight-bold">Delete User</h6>
              <button
                type="button"
                className="btn btn-sm font20 p-0"
                onClick={handleCloseDelete}
                disabled={isDeleting}
              >
                <IoClose />
              </button>
            </div>
            <hr className="my-2" />
            <p className="font13 my-3 text-secondary">
              Are you sure you want to delete user{" "}
              <b className="text-dark">{userToDelete.name}</b>
              {userToDelete.role ? ` (${userToDelete.role})` : ""}?
            </p>

            <div className="d-flex justify-content-end align-items-center mt-3" style={{ gap: "10px" }}>
              <button
                type="button"
                className="user-delete-modal-cancel-btn mr-2"
                onClick={handleCloseDelete}
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                type="button"
                className="user-delete-modal-confirm-btn"
                onClick={handleDeleteUser}
                disabled={isDeleting}
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </Modal.Body>
        </Modal>
      )}

      {/* User creation modal */}
      {requeststatus && (
        <Modal
          show={requeststatus}
          size={!rolestatus ? "md" : "lg"}
          centered
          className="user-modal"
        >
          <Modal.Body className="bg-white">
            <div className="d-flex mb-3 align-items-center">
              <div className="d-flex align-items-center justify-content-between w-100">
                <h6 className="mb-0">User Creation</h6>
              </div>
              <div>
                <button className="btn btn-sm font20" onClick={handleClose} disabled={isCreatingUser}>
                  <IoClose />
                </button>
              </div>
            </div>
            <hr className="my-2" />
            <form className="circlediv" autoComplete="off">
              <div
                className={
                  rolestatus
                    ? "w-100 row mx-auto pt-3 mt-2 borderradius"
                    : undefined
                }
              >
                <div
                  className={
                    !rolestatus
                      ? "col-12 pb-2"
                      : "col-12 col-sm-12 col-md-12 col-lg-6 pb-2"
                  }
                >
                  <div className="field-row d-flex justify-content-between align-items-center">
                    <label
                      htmlFor="role"
                      className="login-text mb-0 d-inline-flex align-items-center"
                    >
                      <BsPersonFillCheck className="blueblue mr-1" />
                      <b className="font12">Choose Role</b>
                      <span className="text-danger ml-1">*</span>
                    </label>
                    {canShow ? (
                      <div>
                        <div className="input-group mb-3">
                          <input
                            onChange={handleAddRoleChange}
                            type="text"
                            className="form-control"
                            placeholder="Enter Role"
                            value={addRole}
                            autoComplete="off"
                          />
                          <div className="input-group-append">
                            <button
                              onClick={handleRolebtn}
                              className="btn border adduserstyle"
                              type="button"
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <select
                        className="project-box pl-2 w-50 font12"
                        id="role"
                        name="role"
                        onKeyPress={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                        value={role}
                        onChange={handleRole}
                      >
                        <option value="">Select</option>
                        <option
                          value="Add New Role"
                          onClick={() => {
                            setCanShow(true);
                          }}
                        >
                          Add New Role
                        </option>
                        {roleList.map((roleName, index) => (
                          <option key={`${roleName}-${index}`} value={roleName}>
                            {roleName}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                  {canShow && (
                    <div className="text-danger d-flex justify-content-end px-3 m-0 font14">
                      <button
                        type="reset"
                        className="clickable-element btn "
                        onClick={() => {
                          setCanShow(false);
                          setAddRole("");
                          setFormErr("");
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                  <div className="text-danger d-flex justify-content-center px-3 m-0">
                    {formErr}
                  </div>
                  <div className="login-error text-center">{roleerror}</div>
                </div>

                {(role === "CE" ||
                  role === "SE" ||
                  role === "DE" ||
                  role === "ADE" ||
                  role === "AE") && (
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                      <div className="field-row d-flex justify-content-between align-items-center">
                        <label className="login-text mb-0 d-inline-flex align-items-center">
                          <PiRoadHorizonBold className="blueblue mr-1" />
                          <b className="font12">Choose Wing</b>
                          <span className="text-danger ml-1">*</span>
                        </label>
                        <select
                          onChange={handleWing}
                          className="project-box w-50 font12"
                          value={wing}
                        >
                          <option value="">Select Wing</option>
                          {wingList.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}

                {(role === "SE" ||
                  role === "DE" ||
                  role === "ADE" ||
                  role === "AE") && (
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                      <div className="field-row d-flex justify-content-between align-items-center">
                        <label
                          htmlFor="circle-select"
                          className="login-text mb-0 d-inline-flex align-items-center"
                        >
                          <i className="ri-apps-2-add-fill rotated-text mr-1"></i>
                          <b className="font12">Choose Circle</b>
                          <span className="text-danger ml-1">*</span>
                        </label>
                        <select
                          id="circle-select"
                          onChange={handleCircle}
                          className="project-box w-50 font12"
                          value={circle}
                        >
                          <option value="">Select Circle</option>
                          {circleList.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}

                {(role === "DE" || role === "ADE" || role === "AE") && (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                    <div className="field-row d-flex justify-content-between align-items-center">
                      <label className="login-text mb-0 d-inline-flex align-items-center">
                        <IoIosBrowsers className="blueblue mr-1" />
                        <b className="font12">Choose Division</b>
                        <span className="text-danger ml-1">*</span>
                      </label>
                      <select
                        onChange={handleDivision}
                        className="project-box w-50 font12"
                        value={division}
                      >
                        <option value="">Select Division</option>
                        {divList.map((item) => (
                          <option
                            className="prepre"
                            key={item.id}
                            value={item.id}
                          >
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                {(role === "ADE" || role === "AE") && (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                    <div className="field-row d-flex justify-content-between align-items-center">
                      <label className="login-text mb-0 d-inline-flex align-items-center">
                        <PiChartPieSliceFill className="blueblue mr-1" />
                        <b className="font12">Choose SubDivision</b>
                        <span className="text-danger ml-1">*</span>
                      </label>
                      <select
                        onChange={handleSubDivision}
                        className="project-box w-50 font12"
                        value={subdiv}
                      >
                        <option value="">Select SubDivision</option>
                        {subdivList.length != 0 &&
                          subdivList.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                )}

                {role === "AE" && (
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6 pb-2">
                    <div className="field-row d-flex justify-content-between align-items-center">
                      <label className="login-text mb-0 d-inline-flex align-items-center">
                        <PiUserCircleFill className="blueblue mr-1" />
                        <b className="font12">Choose Area</b>
                        <span className="text-danger ml-1">*</span>
                      </label>
                      <select
                        onChange={handleArea}
                        className="project-box w-50 font12"
                        value={area}
                      >
                        <option value="">Select Area</option>
                        {areaList.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                <div>
                  {rolestatus && (
                    <div className="px-3 pb-2">
                      <hr />
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="font12 text-muted">
                          Total Users: <b>{fieldValues.length}</b>
                        </span>
                        <button
                          type="button"
                          className="btn d-flex align-items-center justify-content-center user-modal-add-btn"
                          onClick={addFields}
                        >
                          <span>Add User</span>
                          <TiPlus className="font12" />
                        </button>
                      </div>
                    </div>
                  )}

                  {fieldValues.map((field, index) => (
                    <div
                      key={index}
                      className="row px-3 mt-2 font12"
                    >
                      {rolestatus && (
                        <>
                          <div className="col-12 d-flex justify-content-between align-items-center mb-2 pb-1 border-bottom">
                            <span
                              className="font-weight-bold"
                              style={{ color: "#1953aa", fontSize: "12px" }}
                            >
                              User {index + 1}
                            </span>
                            {index > 0 && (
                              <button
                                type="button"
                                className="btn user-modal-delete-btn"
                                onClick={() => removeFields(index)}
                                title={`Delete User ${index + 1}`}
                              >
                                <BiTrash size={14} />
                              </button>
                            )}
                          </div>
                          {[
                            {
                              name: "name",
                              label: "Name",
                              type: "text",
                              maxLen: 50,
                              error: field.nameError,
                              value: field.name,
                              autoComplete: "off",
                            },
                            {
                              name: "mailid",
                              label: "Mail ID",
                              type: "email",
                              maxLen: 50,
                              error: field.mailError,
                              value: field.mailid,
                              autoComplete: "username",
                            },
                            {
                              name: "contnum",
                              label: "Contact Number",
                              type: "text",
                              maxLen: 10,
                              error: field.contnumError,
                              value: field.contnum,
                              autoComplete: "tel",
                            },
                            {
                              name: "designation",
                              label: "Designation",
                              type: "text",
                              maxLen: 100,
                              error: field.designationError,
                              value: field.designation,
                              autoComplete: "off",
                            },
                            {
                              name: "location",
                              label: "Location",
                              type: "text",
                              maxLen: 100,
                              error: field.locError,
                              value: field.location,
                              autoComplete: "off",
                            },
                            {
                              name: "pass",
                              label: "Password",
                              type: "password",
                              maxLen: 16,
                              error: field.passError,
                              value: field.pass,
                              autoComplete: "new-password",
                            },
                          ].map((input) => (
                            <div
                              key={`${input.name}-${index}`}
                              className="col-12 col-sm-12 col-lg-6 col-xl-6 col-md-12 pb-2"
                            >
                              <div className="field-row d-flex justify-content-between align-items-center">
                                <label
                                  htmlFor={`${input.name}-${index}`}
                                  className="login-text mb-0 d-inline-flex align-items-center"
                                >
                                  <b className="font12">{input.label}</b>
                                  {input.name !== "designation" &&
                                    input.name !== "location" && (
                                      <span className="text-danger ml-1">*</span>
                                    )}
                                </label>
                                {input.name === "pass" ? (
                                  <div className="position-relative w-50 d-flex align-items-center">
                                    <InputTextField
                                      index={index}
                                      inputId={`${input.name}-${index}`}
                                      inputName={input.name}
                                      fieldName={input.name}
                                      valueText={input.value}
                                      autoComplete={input.autoComplete}
                                      handleInputChange={(e) =>
                                        handleInputChange(e, index, input.name)
                                      }
                                      inputType={
                                        showPassword[index] ? "text" : "password"
                                      }
                                      classname="project-box pl-2 pr-4 w-100 font12"
                                      maxLen={input.maxLen}
                                    />
                                    <button
                                      type="button"
                                      className="password-toggle-btn"
                                      onClick={() =>
                                        setShowPassword((prev) => ({
                                          ...prev,
                                          [index]: !prev[index],
                                        }))
                                      }
                                      aria-label={
                                        showPassword[index]
                                          ? "Hide password"
                                          : "Show password"
                                      }
                                      tabIndex={-1}
                                    >
                                      {showPassword[index] ? (
                                        <AiOutlineEyeInvisible size={16} />
                                      ) : (
                                        <AiFillEye size={16} />
                                      )}
                                    </button>
                                  </div>
                                ) : (
                                  <InputTextField
                                    index={index}
                                    inputId={`${input.name}-${index}`}
                                    inputName={input.name}
                                    fieldName={input.name}
                                    valueText={input.value}
                                    autoComplete={input.autoComplete}
                                    handleInputChange={(e) =>
                                      handleInputChange(e, index, input.name)
                                    }
                                    inputType={input.type}
                                    classname="project-box pl-2 w-50 font12"
                                    maxLen={input.maxLen}
                                  />
                                )}
                              </div>
                              <span
                                className="text-danger font13"
                                data-testid={`${input.name}-error`}
                              >
                                {input.error}
                              </span>
                            </div>
                          ))}
                          <hr className="mt-1 mx-auto notfullwidth" />
                        </>
                      )}
                    </div>
                  ))}
                </div>

                {formSuccess && (
                  <p className="green-success-text">{formSuccess}</p>
                )}

                <div className="col-sm-12 col-lg-12 col-12 col-md-12 col-xl-12">
                  <div className="d-flex">
                    {rolestatus && (
                      <div className="text-center w-100">
                        <button
                          type="submit"
                          className="search-circle rounded shadow mx-auto heightval user-modal-submit-btn"
                          name="submit"
                          disabled={isCreatingUser}
                          onClick={(e) => handleCreateUser(e)}
                        >
                          <b>{isCreatingUser ? "Submitting..." : "Submit"}</b>
                        </button>
                      </div>
                    )}
                  </div>

                  <p className="text-danger text-center mb-0 mt-2 boldclass">
                    {createFormErr}
                  </p>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      )}
      </div>
    </>
  );
};

export default User;
